import type { AllRouteEndpoints } from "../routeTypes";
export const wabaCreativeOptimizationSettings =
  "/engagement/:app_group_id/whats_app/waba/creative_optimization_settings";

export const postWabaCreativeOptimizationSettingsCacheKeys: AllRouteEndpoints[] = [
  "/engagement/:app_group_id/whats_app/waba/creative_optimization_settings",
];
